import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import { useSelector } from "react-redux";

const CustomTabs = ({ data, setTabState, tabState, onClick }) => {
  const { upcomingEvents, pastEvents } = useSelector((state) => state.events);

  const Upcoming = upcomingEvents?.length || 0;
  const Past = pastEvents?.length || 0;

  return (
    <Stack
      direction={"row"}
      sx={{
        mb: 2,
        justifyContent: "center",
        alignItems: "center",
        border: `1px solid rgba(247,132,25,0.5)`,
        p: 0.5,
        borderRadius: "14px",
        height: "45px",
      }}
    >
      {data.map((tab) => (
        <Box
          sx={{
            backgroundColor:
              tabState === tab.name ? colors.secondary : "transparent",
            width: "100%",
            height: "100%",
            borderRadius: "9px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onClick={() => setTabState(tab.name)}
          key={tab.id}
        >
          <Typography
            sx={{
              color: "#fff",
              fontFamily:
                tabState === tab.name ? "Mulish-SemiBold" : "Mulish-Light",
              fontSize: "14px",
              transition: "all 0.3s ease",
            }}
          >
            {tab.name + ` (${tab.name === "Upcoming" ? Upcoming : Past})`}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default CustomTabs;
